import { makeEntityScaffold } from '@classpass/saga-tools';
import { AppointmentAvailabilityResponse } from '@classpass/protobuf-definitions/lib/web/models/partners/appointment_availability';

import URLS from 'constants/urls';
import { transformKeysToCamelCase } from 'helpers/core';

const handler = ({ httpClient }, venueId, startDate, endDate) => {
  const endpoint = URLS.venue.calendarAvailability({
    venueId,
    startDate,
    endDate,
  });

  return httpClient
    .get(endpoint)
    .then(response => transformKeysToCamelCase(AppointmentAvailabilityResponse.fromJSON(response.data)));
};

export default makeEntityScaffold('SAGA.API.CALENDAR_AVAILABILITY', handler, { defaultKey: [1, 2, 3] });
